module.exports = __webpack_public_path__ + "img/white_logo.52cf6757.png";